export default "https://cdn-static.gokick.com/assets/6e728f413af15b4cc1be7e84aa96f9132e166160/images/sleep-tangerine.755ecdb6db700f77bb8084d276871abe.png";